<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// Main App component for CutPlanner
// Provides the root container for the entire application
</script>

<style scoped>
/* Component-specific styles can be added here */
</style>